import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/api/v1/`,
})

axiosIns.interceptors.request.use(config => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  if (userData && userData.accessToken && userData.authType) {
    const newConfig = { ...config }
    newConfig.headers.Authorization = `Bearer ${userData.accessToken}`
    newConfig.headers.authType = userData.authType
    return newConfig
  }

  return config
})

// logout when the token is invalid when user make a api request
axiosIns.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      const userData = JSON.parse(localStorage.getItem('userData'))
      localStorage.clear()
      localStorage.setItem('logout', true)
      if (userData && userData.authType) {
        if (userData.authType === 'microsoft') {
          window.location.href = `https://${window.location.host}/.auth/me`
        } else {
          window.location.href = '/login'
        }
      }
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
